module.exports = __webpack_public_path__ + "img/ic_info.8a7a3d40.svg";